export { default } from '@mui/utils/generateUtilityClass';